import { AlphabetCollectionsDraftApi, useAPIQuery } from "melco-shared-logic";

export const useFontCollectionsDropdownData = () => {
  return useAPIQuery(
    AlphabetCollectionsDraftApi,
    ["fontCollectionsDropdownData"],
    async (api) => {
      const response = await api.userAlphabetCollectionsGetList({
        offset: 0,
        limit: 100,
        sortBy: "name.asc",
        publishState: "published",
      });

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
